import "../../../css/voucher.css";
import {
  Paper,
  Grid,
  MenuItem,
  FormControl,
  FormGroup,
  FormLabel,
  FormControlLabel,
  Checkbox,
  Button,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import classNames from "classnames";
import DatePicker from "react-datetime";

import Loading from "../../loading";
import Snackbar from "../../snackbar";
import InputFormat from "../../../partials/inputForm";

const styles = (theme) => ({
  editFormContainer: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    padding: theme.spacing(3),
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
  },
  wrapButton: {
    display: "flex",
    justifyContent: "flex-end",
  },
  root: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(3),
    width: "100%",
    boxSizing: "border-box",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    marginBottom: "8px",
  },
  listItem: {
    // width : '100%',
    height: "100%",
    boxShadow:
      "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);",
    position: "relative",
  },
  buttonIcon: {
    width: 64,
    height: 64,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
  },
  icon: {
    cursor: "pointer",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    fontSize: 40,
  },
  buttonHover: {
    width: 36,
    height: 36,
    margin: "0px 5px",
  },
  iconHover: {
    cursor: "pointer",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    fontSize: 24,
  },
  inputImage: {
    display: "none",
  },
  imageItem: {
    height: "250px",
    cursor: "pointer",
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
  title: {
    padding: 0,
    fontSize: "1rem",
    fontWeight: "500",
    lineHeight: "normal",
    height: "3rem",
    color: "#000000",
    fontWeight: 900,
  },
  textField: {
    marginRight: theme.spacing(1),
    width: "100%",
  },
  label: {
    fontWeight: 410,
    color: "#000000",
  },
  formLabel: {
    marginBottom: theme.spacing(1),
    textTransform: "capitalize",
    fontSize: "0.875rem",
  },
  button: {
    float: "right",
    marginLeft: "1rem",
  },
  image: {
    height: "25vw",
    width: "45vw",
    boxShadow:
      "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);",
    backgroundSize: "cover",
    backgroundPosition: "center",
    cursor: "pointer",
  },
  marginTop: {
    marginTop: theme.spacing(3),
  },
  customFormLabel: {
    display: "block",
    color: "rgba(0, 0, 0, 0.85)",
    fontWeight: "500",
  },
  inputType: {
    height: "unset",
  },
});

class EditCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        ...this.props.data,
        password: "",
        username: "",
      },
    };
  }
  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let { data } = this.state;
    data[name] = value;
    this.setState({
      data,
    });
  };
  handleSubmit = async () => {
    const { t } = this.props;
    let { data } = this.state;
    this.loading.startLoading();
    let result = await this.props.updatedeveloperAccount(data);
    this.loading.stopLoading();
    if (result.code === 1) {
      this.mSnackbar.handleClick(t("update_developer_account_success"));
    } else {
      this.mSnackbar.handleClick(t("update_developer_account_unsuccess: ", result.error));
    }
    this.props.finishUpdate(result);
  };
  handleDelete = async () => {
    let { t } = this.props;
    let { data } = this.state;
    let ids = [data.code]
    this.loading.startLoading();
    let check = await this.props.deletedeveloperAccount({ids: ids});
    this.loading.stopLoading();
    if (check.code === 1) {
      this.mSnackbar.handleClick(t("delete_developer_account_success"));
    } else {
      this.mSnackbar.handleClick(t("delete_developer_account_unsuccess: ", check.error));
    }
    this.props.finishDelete(check);
  }
  render() {
    const { classes, t, enableDelete = false } = this.props;
    let { data } = this.state;
    return (
      <Paper square={true} className={classes.editFormContainer}>
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            sm={12}
            style={{ alignItems: "flex-end", display: "flex" }}
          >
            <InputFormat
              label={t("create_developer_account_password")}
              name="password"
              type="password"
              value={data.password}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputFormat
              select
              label={t("create_developer_account_tag")}
              name="tag"
              required
              value={data.tag}
              onChange={this.handleChange}
              fullWidth={true}
            >
              <MenuItem value="sms">
                {t("create_developer_account_sms")}
              </MenuItem>
            </InputFormat>
          </Grid>
          <Grid
            container
            justify="flex-end"
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            {enableDelete &&
              <Button
                variant="contained"
                color="secondary"
                onClick={this.handleDelete}
                className={classes.button}
              >
                {t("update_developer_account_deletebtn")}
              </Button>
            }
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleSubmit}
              className={classes.button}
            >
              {t("Update")}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

EditCard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
});

const mapDispatch = (dispatch) => ({
  updatedeveloperAccount: dispatch.developerAccount.updatedeveloperAccount,
  deletedeveloperAccount: dispatch.developerAccount.deletedeveloperAccount,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(EditCard)));
